/**
 * OrgSelector - This component is used to select an organization from a list. The selection can be locked.
 *
 * @component
 *
 * @param {Object} props - The properties that define the OrgSelector component.
 * @param {string} props.org_id - The id of the organization. If passed, it will be selected by default.
 * @param {boolean} props.locked - If true, the organization selection will be locked and cannot be changed.
 * @param {boolean} props.cantogglelock - If true, the lock can be toggled.
 * @param {Object} props.record - The record object used by react-admin. If org_id is included, it will be set as the org_id in the record.
 *
 * @returns {React.Component} The OrgSelector component
 */

import React, { useState } from "react";
import {
  AutocompleteInput,
  ReferenceInput,
  Button,
  required,
} from "react-admin";

const OrgSelector = (props) => {
  const [lockOverride, setLockOverride] = useState(false);
  const filterToQuery = (searchText) => ({
    name_ilike: `%${searchText || ""}%`,
  });
  let IS_LOCKED = props.locked && props.record && props.record.org_id;

  // Apply lock override
  if (lockOverride) {
    IS_LOCKED = false;
  }

  try {
    if (props.org_id) {
      props.record.org_id = parseInt(props.org_id);
    }
  } catch (e) {
    console.log(e);
  }

  if (props.record && props.record.org_id) {
    props.record.org_id = parseInt(props.record.org_id);
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <ReferenceInput
        {...props}
        reference="organizations"
        source={props.source || "org_id"}
        disabled={IS_LOCKED}
        validate={props.required ? [required()] : []}
        allowEmpty={props.required ? false : true}
      >
        <AutocompleteInput optionText="name" filterToQuery={filterToQuery} />
      </ReferenceInput>
      {props.locked && props.cantogglelock && (
        <Button
          label="Override Lock"
          onClick={() => setLockOverride(!lockOverride)}
        />
      )}
    </div>
  );
};

export default OrgSelector;
